import styled from 'styled-components'

import Button from '@/atoms/Button'

export const StyledLateralNavigation = styled.nav`
  position: fixed;
  top: 50%;
  right: 66px;
  transform: translateY(-50%);
  z-index: ${({ theme }) => theme.layers.base };
  padding: 0;
  text-align: right;
  transition: opacity ease-in-out .4s;
  opacity: 0;

  ${({ visible }) => visible && `
    opacity: 1;
  `}



  ul{
    display: block;
    min-width: 4px;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  li{
    display: table;
    position: relative;
    width: 100%;
  }

  li + li {
    margin-block-start: ${({ theme })=> theme.rem(40)};
  }
`

export const StyledLateralNavigationButton = styled(Button)`
  display: table;
  margin: 0 auto;
  border: none;
  border-radius: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: ${({ theme }) =>theme.rem(10)};

  &:before{
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1,1);
    border-radius: 50%;
    transform-origin: center center;
    transition: transform cubic-bezier(0.72, 0.01, 0.22, 1) .8s, background-color cubic-bezier(0.72, 0.01, 0.22, 1) .8s ;
    will-change: transform, background-color;

    ${({ theme }) => theme.size(8)};
    background-color: ${({ theme }) => theme.colors.grayscale.white(0.5)};

  }

  .default &{
    &::before{
      background-color: ${({ theme }) => theme.colors.primary.default(0.25)};
    }
  }

  &.current,
  &:hover{
    &::before{
      transform: translate(-50%, -50%) scale(1.5,1.5);
      background-color: ${({ theme }) => theme.colors.grayscale.white()};

      .default &{
        background-color: ${({ theme }) => theme.colors.primary.default()};
      }
    }
  }

`
